import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MealTypeModifyComponent } from "./meal-type-modify/meal-type-modify.component";
import { DataService_MealType } from "./shared/data.service";

@Component({
	selector: "app-meal-type-maintenance",
	templateUrl: "./meal-type-maintenance.component.html",
	styleUrls: ["./meal-type-maintenance.component.css"],
})
export class MealTypeMaintenanceComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private userService: UserService,
		private MealTypeService: DataService_MealType,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		// this.loadMeal();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: any;
	School: any;

	processing: any = false;

	ToggleText: any = "Deactivate Meal Type";

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedMeal: any;
	lstMeal: any = [];

	//Filter lists
	lstUsedByDesc: any = [];
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "MealName", header: "Name" },
		{ field: "StartTimeDesc", header: "Start Time" },
		{ field: "EndTimeDesc", header: "End Time" },
		{ field: "MealPrice", header: "Price" },
		{ field: "UsedByDesc", header: "Used By" },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadMeal() {
		this.errorMessage = "";

		this.loading = true;

		var result = this.MealTypeService.MealTypeSelectList(this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstMeal = response;

				//Load Data Filter Lists
				this.lstUsedByDesc = Array.from(new Set(this.lstMeal.map((item: any) => item.UsedByDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstMeal.map((item: any) => item.ActiveDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadMeal();
	}

	//Custom Button Methods
	onAdd() {
		this.errorMessage = "";

		var popup_Width = (window.innerWidth - 80).toString() + "px";

		var ref = this.dialogService.open(MealTypeModifyComponent, {
			header: "Add Meal",
			width: popup_Width,
			data: {
				//INSERT Custom Data here
				user: this.user,
				EditMode: false,
				SchoolID: this.School.SchoolID,
				SchoolName: this.School.SchoolName,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadMeal();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		if (this.SelectedMeal == undefined) {
			this.errorMessage = "Select a Meal Type to edit";
			return;
		}

		if (this.SelectedMeal.SchoolID <= 0 && this.user.UserLevelID != 1) {
			this.errorMessage = "School level users cannot edit district level meal types";
			return;
		}

		var popup_Width = (window.innerWidth - 80).toString() + "px";

		var ref = this.dialogService.open(MealTypeModifyComponent, {
			header: "Edit Meal",
			width: popup_Width,
			data: {
				//INSERT Custom Data here
				user: this.user,
				EditMode: true,
				SchoolID: this.School.SchoolID,
				SchoolName: this.SelectedMeal.SchoolID <= 0 ? "District" : this.School.SchoolName,
				MealID: this.SelectedMeal.MealID,
				MealName: this.SelectedMeal.MealName,
				StartTime: this.SelectedMeal.StartTime,
				EndTime: this.SelectedMeal.EndTime,
				MealPrice: this.SelectedMeal.MealPrice,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadMeal();
			}
		});
	}

	onDelete() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedMeal == undefined) {
			this.errorMessage = "Select a meal type to delete";
			return;
		}

		if (this.SelectedMeal.SchoolID <= 0 && this.user.UserLevelID != 1) {
			this.errorMessage = "School level users cannot delete district level meal types";
			return;
		}

		//Call SP
		this.processing = true;

		var result = this.MealTypeService.MealDelete(this.SelectedMeal.MealID);
		result.subscribe(
			(response) => {
				this.processing = false;

				var lstError: any = response;

				if (lstError.length == 0) {
					this.loadMeal();
				} else {
					var MSG = lstError[0];

					//Error
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: MSG,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.processing = false;
			}
		);
	}

	onToggle() {
		this.errorMessage = "";

		if (this.SelectedMeal == undefined) {
			this.errorMessage = "Select a Meal Type to activate or deactivate";
			return;
		}

		if (this.SelectedMeal.SchoolID <= 0 && this.user.UserLevelID != 1) {
			this.errorMessage = "School level users cannot activate or deactivate district level meal types";
			return;
		}

		var ChangeTo = this.SelectedMeal.Active == true ? 0 : 1;

		var result = this.MealTypeService.MealToggle(this.SelectedMeal.MealID, ChangeTo);
		result.subscribe(
			(response) => {
				if (response) {
					this.onRowUnselect(null);
					this.loadMeal();
				} else {
					var MSG = "Could not ";
					if (ChangeTo == 1) {
						MSG += "activate ";
					} else {
						MSG += "deactivate ";
					}
					MSG += "the meal type";

					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: MSG,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.processing = false;
			},
			(error) => {
				this.processing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onSchoolChange(val) {
		this.errorMessage = "";

		this.School = val;

		this.loadMeal();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedMeal = val.data;

		if (this.SelectedMeal.Active == false) {
			this.ToggleText = "Activate Meal Type";
		} else {
			this.ToggleText = "Deactivate Meal Type";
		}
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedMeal = null;
		this.ToggleText = "Deactivate Meal Type";
	}
	onRowDblClick(Meal) {
		this.errorMessage = "";

		this.SelectedMeal = Meal;

		if (this.SelectedMeal.Active == false) {
			this.ToggleText = "Activate Meal Type";
		} else {
			this.ToggleText = "Deactivate Meal Type";
		}

		this.onEdit();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////
	IsLoading() {
		return this.loading == true || this.processing == true;
	}

	////////////////////////////////////////////
}
